// Website pages (`data-website`) skip PostHog, their largest script. Leaving the website reloads, so the app always tracks.
if (document.documentElement.dataset.website !== "true") {
  // Errors thrown while the chunk loads are queued and sent once PostHog is up.
  const earlyErrors: unknown[] = [];
  const onError = (event: ErrorEvent): void => {
    earlyErrors.push(event.error ?? event.message);
  };
  const onRejection = (event: PromiseRejectionEvent): void => {
    earlyErrors.push(event.reason);
  };
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
  void import("@/lib/error-tracking/init-error-tracking").then(
    ({ initErrorTracking }) => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
      initErrorTracking(earlyErrors);
    },
  );
}
